export default "__VITE_ASSET__ZtGfYOun__"